import { themeQuartz, iconSetMaterial, inputStyleUnderlined } from "ag-grid-community";

// to use myTheme in an application, pass it to the theme grid option
export const eCosTheme = themeQuartz.withPart(iconSetMaterial).withPart(inputStyleUnderlined).withParams({
  accentColor: "#0E4F80",
  backgroundColor: "#fcfcfc",
  browserColorScheme: "light",
  fontFamily: {
    googleFont: "Roboto",
  },
  fontSize: 12,
  foregroundColor: "#252525",
  headerBackgroundColor: "#fcfcfc",
  headerFontWeight: 600,
  headerTextColor: "#757575",
  headerCellHoverBackgroundColor: "#F2F2F2",
  headerColumnResizeHandleColor: "#0A0A0A00",
  listItemHeight: 35,
  oddRowBackgroundColor: "#fcfcfc",
  spacing: 8,
  wrapperBorder: false,
  wrapperBorderRadius: 0,
  checkboxIndeterminateBackgroundColor: "#FFFFFF00",
  checkboxIndeterminateShapeColor: "#FFFFFF00",
  checkboxCheckedBackgroundColor: "#1C79BB",
});